import { Link } from "react-router-dom";
import { applyInfo, festivalInfo } from "@/mocks/festival";

export default function ApplyHero() {
  return (
    <section className="relative w-full bg-primary-900 px-4 md:px-8 pt-28 pb-14 md:pt-36 md:pb-20 overflow-hidden">
      <div className="pointer-events-none absolute -right-20 -top-16 h-72 w-72 rounded-full border border-white/10 animate-floaty-slow"></div>
      <div className="pointer-events-none absolute left-[-8%] bottom-[-20%] h-72 w-72 rounded-full bg-accent-500/20 blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto text-center">
        <nav className="flex items-center justify-center gap-2 text-xs text-background-300">
          <Link to="/" className="cursor-pointer hover:text-white transition-colors">
            홈
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">거봉포도 수확체험 신청</span>
        </nav>

        <span className="mt-6 block text-xs tracking-[0.24em] text-accent-300">ADVANCE BOOKING</span>
        <h1 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-white">
          거봉포도 수확체험 신청
        </h1>
        <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200">
          입장의 거봉포도를 밭에서 직접 수확해 보세요.
          <br className="hidden sm:block" />
          회차별 사전신청으로 운영되며, 아래 신청서를 작성하시면 접수가 완료됩니다.
        </p>

        <div className="mt-9 flex flex-wrap justify-center gap-2.5">
          <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs md:text-sm text-white">
            {festivalInfo.dateText}
          </span>
          <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs md:text-sm text-white">
            회차 {applyInfo.rounds.join(" / ")}
          </span>
          <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs md:text-sm text-white">
            {festivalInfo.venue}
          </span>
        </div>
      </div>
    </section>
  );
}